// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__37Yu0","pagging":"Card_pagging__Biu5w"};